// extracted by mini-css-extract-plugin
export default {"root":"GoToCommentLink-root-49c2b4c6c8af346ce7814325e2fc938f"};